import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { DomainDataService } from '../../../../../services';
import { ExperienceCoursesService } from '../../experience-courses.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'experience-courses-catalog-view-part',
	standalone: true,
	templateUrl: './catalog-view.part.html',
	styleUrls: ['./catalog-view.part.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		GridContentWidget
	]
})
export class ExperienceCoursesCatalogViewPart implements OnInit {

	private readonly service = inject(ExperienceCoursesService);
	private util = inject(UtilityService);
	private readonly domainData = inject(DomainDataService);
	public setup = getSetup(this.service, this.util, this.domainData);
	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.service.layout()) return { layout: this.service.layout()!, viewSelector: true };
		return undefined;
	});

	public readonly courses = computed(() => this.service.courses());

	async ngOnInit() {
		await this.service.getAllCourses();
	}

}